import { IconSprite } from '@components/ui-core/sprite/icon-sprite'
import { LogoSprite } from '@components/ui-core/sprite/logo-sprite'

export default function Sprites() {
  return (
    <>
      <IconSprite />
      <LogoSprite />
    </>
  )
}
